import { TextField, Typography } from '@material-ui/core';
// import { Fragment, memo, useEffect } from 'react';
import * as roleApi from '@api/role';
import { PersonSearch } from '@components/entity-search';
import { useSnackbarInstance } from '@lib/common';
import CircularProgress from '@material-ui/core/CircularProgress';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import React, { memo, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

export const AssociatedPersonDialogContent = memo<any>(
  ({ saveAssociatedPerson, defaultValue, OkPressed, setOkPressed, type}) => {
    // Only set vtrId if editing a person, not from main content
    const [vtrId, setVtrId] = useState(
      defaultValue && defaultValue.person_vtr_id ? defaultValue.person_vtr_id : null
    );
    const [loading, setLoading] = useState(false);
    const [roleData, setRoleData] = useState([]);
    const [subRoleData, setSubRoleData] = useState([]);
    const { enqueue } = useSnackbarInstance();
    const [associatedPerson, setAssociatedPerson] = useState(
      defaultValue
        ? defaultValue.name
          ? {
              name: defaultValue.name,
              person_vtr_id: defaultValue.person_vtr_id,
              person_tmdb_id: defaultValue.person_tmdb_id,
            }
          : null
        : null
    );
    const [role, setRole] = useState(defaultValue ? defaultValue.role : null);
    const [subRole, setSubRole] = useState(defaultValue ? defaultValue?.sub_role : null);
    // const [subRoleOptions, setSubRoleOp]
    const [character, setCharacter] = useState(defaultValue ? defaultValue.character : null);
    useEffect(() => {
      if (OkPressed) {
        const saveAssociatedPersonDetails = {
          ...(typeof associatedPerson === 'string'
            ? { name: associatedPerson, person_vtr_id: null, person_tmdb_id: null }
            : {
                name: associatedPerson ? associatedPerson.name : null,
                person_vtr_id: associatedPerson ? associatedPerson.person_vtr_id : vtrId,
                person_tmdb_id: associatedPerson ? associatedPerson.person_tmdb_id : null,
              }),
          role: role,
          sub_role: subRole,
          character: character,
        };
        if (associatedPerson && role) saveAssociatedPerson(saveAssociatedPersonDetails);
        setOkPressed(false);
      }
    }, [OkPressed]);
  
    useEffect(()=>{
      if(associatedPerson){
         setLoading(true);
          roleApi.roleSearch().subscribe({
          next: val => {
            setRoleData(val);
          },
          error: val => {
            enqueue(`Error while get Role : ${val}`, { variant: 'error' });
          },
          complete: () => {
            setLoading(false);
          },
        });
      }
    },[associatedPerson])

    useEffect(()=>{
      if(role){
        roleApi.subRoleSearch().subscribe({
          next: val => {
            const subRoleList = val[role] ?? []
            setSubRoleData(subRoleList);
          },
          error: val => {
            enqueue(`Error while get Role : ${val}`, { variant: 'error' });
          },
          complete: () => {
            setLoading(false);
          },
        });
      }
    },[role])

    return (
      <>
        <Typography variant="subtitle1">Cast and Crew Member</Typography>
        <br />
        <ControlledAutoCompleteField
          associatedPerson={associatedPerson}
          setAssociatedPerson={setAssociatedPerson}
        />
        <br />
        {/* <br /> */}
        <Typography variant="subtitle1">Role</Typography>
        <br />
        <CountryStyles>
          <Autocomplete
            value={role}
            onChange={(evt, v) => setRole(v)}
            // onInputChange={(evt, v) => onChange && onChange(v)}
            options={roleData || []}
            // disabled={loading}
            renderInput={props => (
              <TextField
                label="Role"
                fullWidth
                variant="outlined"
                error={OkPressed && !role}
                helperText={OkPressed && role ? null : 'Role of the member is mandatory'}
                {...props}
                InputProps={{
                  ...props.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <>
                          <CircularProgress color="inherit" size={20} />
                          {props.InputProps.endAdornment}
                        </>
                      ) : null}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </CountryStyles>
        <br />
        <br />
        <Typography variant="subtitle1">Sub Role</Typography>
        <br />
        <CountryStyles>
          <Autocomplete
            value={subRole}
            onChange={(evt, v) => setSubRole(v)}
            // onInputChange={(evt, v) => onChange && onChange(v)}
            options={subRoleData || []}
            // disabled={loading}
            renderInput={props => (
              <TextField
                label="Role"
                fullWidth
                variant="outlined"
                error={OkPressed && !subRole}
                helperText={OkPressed && subRole ? null : 'Role of the member is mandatory'}
                {...props}
                InputProps={{
                  ...props.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <>
                          <CircularProgress color="inherit" size={20} />
                          {props.InputProps.endAdornment}
                        </>
                      ) : null}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </CountryStyles>
        <br />
        <br />
        <Typography variant="subtitle1">Character</Typography>
        <br />
        <ControlledTextFieldforCharacter
          fullWidth
          variant="outlined"
          character={character}
          setCharacter={setCharacter}
        />
      </>
    );
  }
);

const ControlledTextField = ({ role, setDesignation, ...props }) => {
  const callbackOnChange = useCallback(e => setDesignation(e.target.value), []);
  return <TextField {...props} value={role} label={'Role'} onChange={callbackOnChange} />;
  // }
};

export const ControlledTextFieldforCharacter = ({ character, setCharacter, ...props }) => {
  const callbackOnChangechar = useCallback(e => setCharacter(e.target.value), []);
  return (
    <TextField
      {...props}
      value={character}
      label={'Character in the Movie'}
      onChange={callbackOnChangechar}
      style={{minWidth:'200px'}}
    />
  );
  // }
};

const ControlledAutoCompleteField = ({ associatedPerson, setAssociatedPerson, ...props }) => {
  return (
    <PersonSearch
      associatedPerson={associatedPerson}
      setAssociatedPerson={setAssociatedPerson}
      label="Cast and Crew Members"
      freeSolo={false}
    />
  );
};

const CountryStyles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;
